export const routes = {
  publicHome: '/',
  account: '/account',
  home: '/home',
  login: '/login',
  insight: '/insights',
  register: '/register',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  activate: '/activate',
  surveys: '/surveys',
  collector: '/collector',
  chart: '/chart',
  surveyNew: '/new',
  edit: '/edit',
  respond: '/respond',
  preview: '/preview',
  sessions: '/sessions',
  settings: '/settings',
  subscription: '/subscription',
  restoreAccount: '/restore-account',
  subscriptionSuccess: '/success',
  subscriptionCancel: '/cancel',
  help: '/help',
  documents: '/documents',
  projects: '/projects',
  // Retired screens — kept only so the legacy redirects have one source of
  // truth. The Impact Register is a tab on the project page now.
  stakeholderGroups: '/stakeholder-groups',
  impacts: '/impacts',
  ssoCallback: '/sso/callback'

}

export const colors = {
  main: '#00438E',
  secondary: '#858fbb',
  mainLight: '#f6f8ff',
  white: 'white',
  success: '#008f2d',
  disabled: '#858585',
  config: '#828c70',
  grey: '#F2F3F8',
  lavenderWeb: '#D7DBEA',
  darkgrey: 'rgba(11,34,63,0.84)',
  darkBlue: '#002356',
  green: '#008f2d',
  lightgreen: '#78C091',
  red: '#FF785A',
  greyhighlight: '#E4E7F1'
}

export const token_keys = {
  access_token: 'access-token',
  refresh_token: 'refresh-token',
  csrf_token: 'csrftoken',
  expiration: 'expiration',
  issued_at: 'issued_at',
  // Timestamp (ms) of the user's last interaction. Kept in localStorage rather
  // than in a ref so that activity in ANY open tab counts as activity for all
  // of them — otherwise a background tab would idle out and log the user out
  // from under the tab they are actually working in. See useSessionTimeout.
  last_activity: 'last_activity'
}

